import { Button, Row, Typography } from 'antd'
import ClientForm from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/Client/ClientForm'
import ClientList from '../../../../../../components/Corporate/Analytics/Reports/ReportsComponents/Client/ClientList'
import MoneyCell from '../../../../../../elements/Table/Cells/MoneyCell'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import React from 'react'

const { Title } = Typography

function ClientDisplay(props) {
  const { formRef, submitting, submit, data, onClickNum } = props
  const columns = [
    { Header: 'Code', accessor: 'code', width: 100 },
    {
      Header: 'Name',
      accessor: 'name',
      style: { paddingLeft: 20, alignment: 'left' },
    },
    {
      Header: 'Client ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Partner ID',
      accessor: 'partner._id',
      hideable: true,
      hideDefault: true,
    },

    {
      Header: 'Sales',
      accessor: 'sales',
      width: 200,
      Cell: ({ value }) => {
        return (
          <a onClick={() => onClickNum(null, 'sales', value.data)}>
            {MoneyCell({ value: value.total, currency: 'USD' })}
          </a>
        )
      },
    },

    {
      Header: 'Cost',
      accessor: 'cost',
      width: 200,
      Cell: ({ value }) => {
        return (
          <a onClick={() => onClickNum(null, 'purchases', value.data)}>
            {MoneyCell({ value: value.total, currency: 'USD' })}
          </a>
        )
      },
    },

    {
      Header: 'Margin',
      accessor: 'margin.total',
      width: 200,
      Cell: ({ value }) => MoneyCell({ value, currency: 'USD' }),
    },
    {
      Header: 'Margin',
      accessor: 'margin.percentage',
      width: 200,
      Cell: ({ value }) => MoneyCell({ value, currency: '%' }),
    },
  ]

  return (
    <>
      <ClientList {...props} />
      <Row>
        <ClientForm ref={formRef} {...props} />
        <Button style={{ width: '100px' }} type="primary" loading={submitting} onClick={submit}>
          Submit
        </Button>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <CustomTable
          data={data}
          defaultPageSize={20}
          isFilterable={true}
          show={{ csv: { fileName: `Client-Report` } }}
          fetching={submitting}
          columns={columns}
          defaultSorted={[{ id: 'margin.total' }]}
        />
      </Row>
    </>
  )
}

export default ClientDisplay
